import { IconOption } from 'components/Icon'
import React, { ReactNode } from 'react'
import { S } from './OrganizationForm'

interface OverviewItemProps {
    title: string
    icon: IconOption
    children: ReactNode
    renderAction?: () => ReactNode
}

const OverviewItem = ({
    title, children, icon, renderAction
}: OverviewItemProps) => (
    <S.Overview.Item>
        <S.Overview.Icon icon={icon} />
        <div>
            <S.Overview.ItemHeader>
                {title}
            </S.Overview.ItemHeader>
            <S.Overview.ItemContent>
                {children}
            </S.Overview.ItemContent>
        </div>
        {renderAction?.()}
    </S.Overview.Item>
)

export default OverviewItem
